import { Injectable } from '@angular/core';

// Define event types without shouldReact
export type QueueEventInput =
  | { type: 'createFile'; filename: string; content: string; output: string }
  | { type: 'view'; filename: string; output: string }
  | { type: 'command'; command: string; output: string; viewOutput: boolean }
  | { type: 'mcpToolResponse'; tool: string; output: string }
  | { type: 'question'; content: string; }
  | { type: 'answer'; content: string; }
  | { type: 'error'; content: string };

// Map event types to shouldReact values
export type QueueEvent = QueueEventInput & { shouldReact: boolean };

const shouldReactMap: Record<QueueEventInput['type'], boolean> = {
  createFile: true,
  command: true,
  mcpToolResponse: true,
  view: true,
  question: false,
  answer: false,
  error: true,
};

function withShouldReact(event: QueueEventInput): QueueEvent {
  return { ...event, shouldReact: shouldReactMap[event.type] };
}

@Injectable({
  providedIn: 'root',
})
export class QueueService {
  constructor() { }
  private queue: QueueEvent[] = [];

  add(event: QueueEventInput) {
    this.queue.push(withShouldReact(event));
  }

  get(): QueueEvent | undefined {
    return this.queue.shift();
  }

  getAll(): { allEvents: QueueEvent[]; shouldReact: boolean } {
    const allEvents = [...this.queue];
    const shouldReact = allEvents.some(event => event.shouldReact);
    this.queue = [];
    return { allEvents, shouldReact };
  }
}
